import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { PlusCircle, Image, Send, ArrowLeft, FileText, Trash2 } from 'react-feather';
import { Modal, Button, Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import api from '../Api';

function WorkOrderDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [previewImg, setPreviewImg] = useState(null);
  const [show, setShow] = useState(false);
  const [showAssignment, setShowAssignment] = useState(false);
  const [assignmentType, setAssignmentType] = useState('');
  const [selectedGroup, setSelectedGroup] = useState('');
  const [selectedMembers, setSelectedMembers] = useState([]);
  const [manualMembers, setManualMembers] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState(''); // "ambil" | "reject"
  const [loading, setLoading] = useState(true);
  const [detail, setDetail] = useState(null);
  const [userOptions, setUserOptions] = useState([]);
  const [loadingPetugas, setLoadingPetugas] = useState(false);
  const [groupOptions, setGroupOptions] = useState([]); // daftar group
  const [groupMembers, setGroupMembers] = useState([]); // anggota dari group
  const [loadingGroup, setLoadingGroup] = useState(false);
  const [showConfirmMember, setShowConfirmMember] = useState(false);
  const [pendingMember, setPendingMember] = useState(null);
  const authUser = JSON.parse(localStorage.getItem('user'));
  const roleId = authUser?.role_id;
  const STORAGE_BASE_URL = 'https://apiworkorder.perumdamtkr.com/storage/';

  const canTakeTicket = () => {
    if (!detail) return false;

    const { category, status } = detail;

    // hanya tiket NEW yang bisa diambil
    if (status !== 'new') return false;

    // Admin → administratif
    if (roleId === 1 && category === 'administratif') return true;

    // Petugas teknikal → teknical
    if (roleId === 4 && category === 'teknical') return true;

    return false;
  };

  useEffect(() => {
    const fetchDetail = async () => {
      try {
        const res = await api.get(`/work-orders/${id}/details`);
        if (res.data.success) {
          setDetail(res.data);
        } else {
          toast.error('Gagal memuat detail tiket');
        }
      } catch (err) {
        console.error('Error ambil detail tiket:', err);
        toast.error('Terjadi kesalahan saat memuat data!');
      } finally {
        setLoading(false);
      }
    };
    fetchDetail();
  }, [id]);

  useEffect(() => {
    const fetchPetugasByWilayah = async () => {
      if (assignmentType !== 'manual' || !detail?.wilayah_id) return;

      setLoadingPetugas(true);
      try {
        const res = await api.get(`/user/petugas/by-wilayah?wilayah_id=${detail.wilayah_id}`);

        const data = res.data.data || [];
        // Hanya tampilkan petugas yang statusnya "available"
        const availableUsers = data.filter((u) => u.status_petugas === 'ready');

        const formattedOptions = availableUsers.map((u) => ({
          value: u.id,
          label: `${u.full_name} - ${u.status_petugas}`,
        }));

        setUserOptions(formattedOptions);
      } catch (error) {
        console.error('Gagal memuat daftar petugas:', error);
        toast.error('Gagal memuat daftar petugas berdasarkan wilayah!');
      } finally {
        setLoadingPetugas(false);
      }
    };

    fetchPetugasByWilayah();
  }, [assignmentType, detail?.wilayah_id]);

  useEffect(() => {
    const fetchGroups = async () => {
      try {
        const res = await api.get('/user/work-groups/petugas');

        if (res.data.status && Array.isArray(res.data.data)) {
          setGroupOptions(
            res.data.data.map((g) => ({
              id: g.id,
              name: g.name,
            })),
          );
        } else {
          setGroupOptions([]);
          toast.warning('Tidak ada group petugas!');
        }
      } catch (error) {
        console.error('Gagal memuat group petugas:', error);
        toast.error('Gagal memuat group petugas!');
      }
    };

    fetchGroups();
  }, []);

  // 🔹 Ambil anggota ketika group dipilih
  useEffect(() => {
    const fetchGroupMembers = async () => {
      if (!selectedGroup) return;

      setLoadingGroup(true);
      try {
        const res = await api.get(`/group/members/${selectedGroup}`);

        if (res.data.status && Array.isArray(res.data.members)) {
          setGroupMembers(res.data.members);
        } else {
          setGroupMembers([]);
          toast.warning('Tidak ada anggota di group ini!');
        }
      } catch (error) {
        console.error('Gagal memuat anggota group:', error);
        toast.error('Gagal memuat anggota group!');
      } finally {
        setLoadingGroup(false);
      }
    };

    fetchGroupMembers();
  }, [selectedGroup]);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center py-5">
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  if (!detail) {
    return <div className="alert alert-danger text-center mt-4">Data tidak ditemukan.</div>;
  }

  // === HANDLE KIRIM TIKET KE GROUP ===
  const handleSubmitAssignGroup = async (e) => {
    e.preventDefault();

    if (!selectedGroup) {
      toast.warning('Pilih group terlebih dahulu!');
      return;
    }

    if (selectedMembers.length === 0) {
      toast.warning('Pilih minimal satu petugas terlebih dahulu!');
      return;
    }

    try {
      setLoadingGroup(true);

      const payload = {
        work_order_id: detail.work_order_id,
        group_id: selectedGroup,
        petugas_ids: selectedMembers,
      };

      const res = await api.post('/work-orders/assign/group', payload);

      if (res.data.success) {
        toast.success(res.data.message || 'Tiket berhasil dikirim ke group');
        setSelectedMembers([]);
        setShowAssignment(false);

        setTimeout(() => {
          redirectToNewTab();
        }, 1500);
      } else {
        toast.error(res.data.message || 'Gagal mengirim tiket!');
      }
    } catch (err) {
      console.error('❌ Gagal kirim tiket:', err);
      toast.error(err.response?.data?.message || 'Terjadi kesalahan server!');
    } finally {
      setLoadingGroup(false);
    }
  };

  const handleSubmitAssignManual = async () => {
    if (manualMembers.length === 0) {
      toast.warning('Pilih minimal satu petugas!');
      return;
    }

    try {
      setLoadingGroup(true);

      const payload = {
        work_order_id: detail.work_order_id,
        petugas_ids: manualMembers.map((m) => m.id),
      };

      const res = await api.post('/work-orders/assign/custom', payload);

      if (res.data.success) {
        toast.success(res.data.message || 'Tiket berhasil dikirim ke petugas');
        setManualMembers([]);
        setShowAssignment(false);

        setTimeout(() => {
          redirectToNewTab();
        }, 1500);
      } else {
        toast.error(res.data.message || 'Gagal mengirim tiket!');
      }
    } catch (err) {
      console.error(err);
      toast.error(err.response?.data?.message || 'Server error');
    } finally {
      setLoadingGroup(false);
    }
  };

  // Toggle member
  const handleToggleMember = (id) => {
    setSelectedMembers((prev) => (prev.includes(id) ? prev.filter((m) => m !== id) : [...prev, id]));
  };

  const handleCheckboxClick = (m) => {
    const alreadySelected = selectedMembers.includes(m.id);

    // Jika sudah tercentang → artinya user mau uncheck, langsung saja tanpa modal
    if (alreadySelected) {
      handleToggleMember(m.id);
      return;
    }

    // Jika belum tercentang → artinya user mau check
    if (m.status_petugas === 'ready') {
      handleToggleMember(m.id);
    } else {
      // Bukan ready → tampilkan modal konfirmasi dulu
      setPendingMember(m);
      setShowConfirmMember(true);
    }
  };

  const handleConfirmMember = () => {
    if (pendingMember) {
      handleToggleMember(pendingMember.id);
    }
    setPendingMember(null);
    setShowConfirmMember(false);
  };

  const handleAddManual = (option) => {
    const user = userOptions.find((u) => u.value === option.value);
    if (user && !manualMembers.find((m) => m.id === user.value)) {
      setManualMembers((prev) => [...prev, { id: user.value, name: user.label, role: user.label.split(' - ')[1] }]);
    }
  };

  const handleRemoveManual = (id) => {
    setManualMembers((prev) => prev.filter((m) => m.id !== id));
  };

  // === HANDLE PREVIEW ===
  const handlePreview = (img) => {
    setPreviewImg(img);
    setShow(true); // buka modal
  };

  const handleClose = () => {
    setShow(false); // tutup modal
    setPreviewImg(null);
  };

  const handleOpenModal = (type) => {
    setModalType(type);
    setShowModal(true);
  };

  const handleConfirm = async () => {
    if (modalType === 'ambil') {
      try {
        // Kirim ke API /work-orders/take
        const res = await api.post('/work-orders/take', {
          work_order_id: detail.work_order_id,
        });

        if (res.data.success) {
          toast.success(res.data.message || 'Tiket berhasil diambil!');
          setShowModal(false);

          // Setelah ambil tiket, redirect kembali ke halaman daftar tiket
          setTimeout(() => {
            navigate('/Wo/WorkOrder?tab=new&page=1');
          }, 1500);
        } else {
          toast.error('Gagal mengambil tiket!');
        }
      } catch (err) {
        console.error('Gagal ambil tiket:', err);
        toast.error(err.response?.data?.message || 'Terjadi kesalahan saat ambil tiket!');
      }
    }

    // Jika nanti mau tambah fitur reject, bisa tambahkan else if (modalType === "reject")
  };

  const redirectToNewTab = () => {
    navigate('/Wo/WorkOrder?tab=new&page=1');
  };

  return (
    <>
      <div className="container mt-4">
        <div className="card shadow-sm">
          {/* Header utama */}
          <div className="card-header" style={{ backgroundColor: '#1a237e' }}>
            <h5 className="mb-0 text-white">Detail Tiket {detail.external_ref}</h5>
          </div>

          <div className="card-body">
            <div className="d-flex justify-content-end px-3 py-2" style={{ backgroundColor: '#f5f6fa' }}></div>

            {/* Tabel detail */}
            <div className="table-responsive">
              <table className="table table-bordered align-middle">
                <tbody>
                  <tr>
                    <th style={{ width: '20%' }}>ID Pelanggan</th>
                    <td style={{ width: '30%' }}>{detail.id_pelanggan}</td>
                    <th style={{ width: '20%' }}>Nama Pelanggan</th>
                    <td style={{ width: '30%' }}>{detail.nama}</td>
                  </tr>
                  <tr>
                    <th style={{ width: '20%' }}>Jenis Pengaduan</th>
                    <td style={{ width: '30%' }}>{detail.nm_pengaduan}</td>
                    <th style={{ width: '20%' }}>Telepon</th>
                    <td style={{ width: '30%' }}>{detail.no_hp}</td>
                  </tr>
                  <tr>
                    <th>Alamat</th>
                    <td>{detail.alamat}</td>
                    <th>Status Pelanggan</th>
                    <td>{detail.customer}</td>
                  </tr>
                  <tr>
                    <th>Media</th>
                    <td>{detail.nama_channel}</td>
                    <th>Category</th>
                    <td>{detail.category}</td>
                  </tr>
                  <tr>
                    <th>Wilayah</th>
                    <td>{detail.nama_wilayah}</td>
                    <th>Provinsi</th>
                    <td>{detail.nama_propinsi}</td>
                  </tr>
                  <tr>
                    <th>Kabupaten</th>
                    <td>{detail.nama_kabupaten}</td>
                    <th>Kecamatan</th>
                    <td>{detail.nama_kecamatan}</td>
                  </tr>
                  <tr>
                    <th>Kelurahan</th>
                    <td>{detail.nama_kelurahan}</td>
                    <th>Priority</th>
                    <td>
                      <span
                        className={`badge ${
                          detail.priority === 'critical'
                            ? 'bg-danger'
                            : detail.priority === 'medium'
                              ? 'bg-warning text-dark'
                              : 'bg-success'
                        }`}
                      >
                        {detail.priority}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <th>Keluhan</th>
                    <td>{detail.description}</td>
                    <th>Bukti Foto</th>
                    <td>
                      {detail.complaint_pic ? (
                        <button
                          className="btn btn-sm btn-primary d-flex align-items-center"
                          onClick={() => handlePreview(`${STORAGE_BASE_URL}${detail.complaint_pic}`)}
                        >
                          <Image size={16} className="me-1" />
                          Lihat Gambar
                        </button>
                      ) : (
                        <span className="text-muted">Tidak ada bukti foto</span>
                      )}
                    </td>
                  </tr>
                  {[2, 3].includes(JSON.parse(localStorage.getItem('user'))?.role_id) && (
                    <tr>
                      <th>Aksi</th>
                      <td colSpan={3}>
                        <button
                          className="btn text-white d-flex align-items-center"
                          style={{ backgroundColor: 'rgb(29, 145, 37)' }}
                          onClick={() => setShowAssignment(!showAssignment)}
                        >
                          <PlusCircle size={18} className="me-2" />
                          Penugasan Tiket
                        </button>
                      </td>
                    </tr>
                  )}
                  {canTakeTicket() && (
                    <tr>
                      <th>Aksi</th>
                      <td colSpan={3}>
                        <button
                          className="btn btn-sm text-white d-flex align-items-center"
                          style={{ backgroundColor: 'rgb(29, 145, 37)' }}
                          onClick={() => handleOpenModal('ambil')}
                        >
                          <FileText size={16} className="me-1" />
                          Ambil Tiket
                        </button>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Section Penugasan */}
            {showAssignment && (
              <div className="card">
                <div className="py-3 px-3 text-white" style={{ backgroundColor: '#3949ab' }}>
                  <h6 className="mb-0 text-white">Penugasan Tiket</h6>
                </div>
                <div className="card-body">
                  {/* Pilih metode */}
                  <div className="mb-3">
                    <label className="form-label">Pilih Metode Penugasan</label>
                    <select
                      className="form-select"
                      value={assignmentType}
                      onChange={(e) => {
                        setAssignmentType(e.target.value);
                        setSelectedGroup('');
                        setSelectedMembers([]);
                      }}
                    >
                      <option value="">-- Pilih --</option>
                      <option value="group">Kirim ke Group Petugas</option>
                      <option value="manual">Tambah Petugas Manual</option>
                    </select>
                  </div>

                  {/* Jika pilih group */}
                  {assignmentType === 'group' && (
                    <>
                      {/* Dropdown pilih group */}
                      <div className="mb-3">
                        <label className="form-label">Pilih Group</label>
                        <select
                          className="form-select"
                          value={selectedGroup}
                          onChange={(e) => {
                            setSelectedGroup(e.target.value);
                            setSelectedMembers([]);
                          }}
                        >
                          <option value="">-- Pilih Group --</option>
                          {groupOptions.map((g) => (
                            <option key={g.id} value={g.id}>
                              {g.name}
                            </option>
                          ))}
                        </select>
                      </div>

                      {/* Tabel anggota group */}
                      {groupMembers.length > 0 && (
                        <form onSubmit={handleSubmitAssignGroup}>
                          <div className="table-responsive">
                            <table className="table table-bordered align-middle text-center">
                              <thead>
                                <tr>
                                  <th>Nama Petugas</th>
                                  <th>Posisi</th>
                                  <th>Status</th>
                                  <th>Pilih</th>
                                </tr>
                              </thead>
                              <tbody>
                                {groupMembers.map((m) => (
                                  <tr key={m.id}>
                                    <td>{m.full_name}</td>
                                    <td>{m.position}</td>
                                    <td>
                                      <span
                                        className={`badge ${
                                          m.status_petugas === 'ready' ? 'bg-success' : 'bg-secondary'
                                        }`}
                                      >
                                        {m.status_petugas}
                                      </span>
                                    </td>
                                    <td>
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        checked={selectedMembers.includes(m.id)}
                                        onChange={() => handleCheckboxClick(m)}
                                      />
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>

                            <button
                              className="btn btn-kirim d-flex align-items-center"
                              type="submit"
                              disabled={loadingGroup}
                            >
                              <Send size={16} className="me-2" />
                              {loadingGroup ? 'Mengirim...' : 'Kirim Tiket'}
                            </button>
                          </div>
                        </form>
                      )}
                    </>
                  )}

                  {/* Jika pilih manual */}
                  {assignmentType === 'manual' && (
                    <div>
                      <div className="mb-3">
                        <label className="form-label">Cari & Tambah Petugas</label>
                        <Select
                          options={userOptions}
                          onChange={handleAddManual}
                          placeholder={
                            loadingPetugas
                              ? 'Memuat daftar petugas...'
                              : userOptions.length === 0
                                ? 'Tidak ada petugas tersedia di wilayah ini'
                                : 'Cari nama petugas...'
                          }
                          isDisabled={loadingPetugas || userOptions.length === 0}
                          isSearchable
                        />
                      </div>

                      {/* Tabel petugas yang dipilih */}
                      {manualMembers.length > 0 && (
                        <div className="table-responsive">
                          <table className="table table-bordered align-middle text-center">
                            <thead>
                              <tr>
                                <th>Nama</th>
                                <th>Role</th>
                                <th className="text-center">Aksi</th>
                              </tr>
                            </thead>
                            <tbody>
                              {manualMembers.map((m) => (
                                <tr key={m.id}>
                                  <td>{m.name}</td>
                                  <td>{m.role}</td>
                                  <td className="text-center">
                                    <button className="btn btn-sm btn-danger" onClick={() => handleRemoveManual(m.id)}>
                                      <Trash2 size={16} />
                                      Hapus
                                    </button>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                          <button
                            className="btn btn-kirim d-flex align-items-center"
                            type="button"
                            onClick={handleSubmitAssignManual}
                            disabled={loadingGroup}
                          >
                            <Send size={16} className="me-2" />
                            {loadingGroup ? 'Mengirim...' : 'Kirim Tiket'}
                          </button>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* Action buttons */}
            {/* Footer Aksi */}
            <div className="d-flex justify-content-between mt-3">
              {/* Kiri */}
              <div>
                <button className="btn btn-secondary d-flex align-items-center" onClick={() => navigate(-1)}>
                  <ArrowLeft size={16} className="me-1" />
                  Kembali
                </button>
              </div>

              {/* Kanan */}
              <div></div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal Preview */}
      <Modal show={show} onHide={handleClose} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Preview Foto</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          {previewImg ? (
            <img src={previewImg} alt="Preview" className="img-fluid rounded shadow" />
          ) : (
            <p className="text-muted">Tidak ada gambar</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Tutup
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>{modalType === 'ambil' ? 'Konfirmasi Ambil Tiket' : 'Konfirmasi Reject Tiket'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {modalType === 'ambil'
            ? 'Apakah Anda yakin ingin mengambil tiket ini?'
            : 'Apakah Anda yakin ingin menolak (reject) tiket ini?'}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Batal
          </Button>
          <Button variant={modalType === 'ambil' ? 'success' : 'danger'} onClick={handleConfirm}>
            {modalType === 'ambil' ? 'Ambil Tiket' : 'Reject Tiket'}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal Konfirmasi Kirim ke Petugas Non-Ready */}
      <Modal show={showConfirmMember} onHide={() => setShowConfirmMember(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Konfirmasi Kirim Tiket</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Apakah anda yakin ingin mengirim tiket ke <strong>{pendingMember?.full_name}</strong> dengan status{' '}
          <strong>{pendingMember?.status_petugas}</strong>?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowConfirmMember(false)}>
            Batal
          </Button>
          <Button variant="primary" onClick={handleConfirmMember}>
            Ya, Kirim
          </Button>
        </Modal.Footer>
      </Modal>
      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
}

export default WorkOrderDetail;
